module.exports = __webpack_public_path__ + "media/images/links/min_salud-26605468b1bffc543cf8752af47fdf96.jpg";